export const SALE_TRANSACTION_FINISHED = "SALE_TRANSACTION_FINISHED";
export const LOCATION_CHANGE = "LOCATION_CHANGE";
export const UPLOAD_ERROR_EVENT = "UPLOAD_ERROR_EVENT";
export const PROMOTION_CALCULATION_STARTING = "PROMOTION_CALCULATION_STARTING";
export const PROMOTION_CALCULATION_FINISHED = "PROMOTION_CALCULATION_FINISHED";
